import React, { useState, useEffect } from "react";
import {
  getPurchaseCart,
  deletePurchaseCart,
  clearError,
  clearMessage,
} from "../redux/manageProductSlice";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PayPurchaseModel from "./PayPurchaseModel";
import EditPurchaseModel from "./EditPurchaseModel";
import ConfirmationModal from "../BaseFiles/ConfirmationModel";
import { ToastContainer, toast } from "react-toastify";

export default function PurchaseOrders() {
  const dispatch = useDispatch();
  const [deletedID, setDeletedID] = useState(null);
  const [visible, setVisible] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const { purchasecart, loading, error, message } = useSelector(
    (state) => state.manageProduct
  );
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedPaymentOption, setSelectedPaymentOption] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    dispatch(getPurchaseCart());
    if (error) {
      toast(error);
      dispatch(clearError());
    }
    if (message) {
      toast(message);
      dispatch(clearMessage());
    }
  }, [error, message, dispatch]);

  function CloseModel() {
    setDeletedID(null);
    setVisible(false);
    setShowPaymentModal(false);
    setShowEditModal(false);
  }

  function deletePurcahseCart() {
    dispatch(deletePurchaseCart(deletedID));
    CloseModel();
  }

  function handleDelete(id) {
    setDeletedID(id);
    setVisible(true);
  }

  function handleEdit(item) {
    setSelectedItem(item);
    setShowEditModal(true);
  }

  const handlePaymentOption = (option) => {
    setSelectedPaymentOption(option);
    setShowPaymentModal(true);
  };

  const calculateTotalAmount = () => {
    return filteredProducts?.reduce(
      (total, item) => total + item.purchasePricePack * item.quantity,
      0
    );
  };

  const calculateTotalQantity = () => {
    return filteredProducts?.reduce((qyt, item) => qyt + item.quantity, 0);
  };

  const filteredProducts = purchasecart?.filter((product) =>
    product.product_name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <div className="px-4 sm:px-6 lg:px-0">
        <ToastContainer />
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <p className=" font-semibold ">
              Total Amount: Rs{calculateTotalAmount()}
            </p>
            <p className="font-semibold ">
              Total Quantity: {calculateTotalQantity()} Packs
            </p>
          </div>
          {filteredProducts?.length > 0 && (
          <div className="flex gap-x-4">
            <input
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search Products"
              className="border p-2 rounded-full w-64"
            />
            <button
              onClick={() => handlePaymentOption("full")}
              className="bg-green-500 rounded-lg w-[140px] p-2 text-white text-center font-medium"
            >
              Pay
            </button>
            <button
              onClick={() => handlePaymentOption("discount")}
              className="bg-yellow-500 rounded-lg p-2 w-[140px] text-white text-center font-medium"
            >
              Discounted
            </button>
            <button
              onClick={() => handlePaymentOption("cancel")}
              className="bg-red-500 rounded-lg p-2 w-[140px] text-white text-center font-medium"
            >
              Clear Order
            </button>
          </div>)}
        </div>
        <div className="mt-8 flow-root">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <table className="min-w-full divide-y divide-gray-300">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                    >
                      Name
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Quantity
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Price/pack
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Total Amount
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Entry
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {filteredProducts?.map((product) => (
                    <tr key={product.email}>
                      <td className="whitespace-nowrap py-5 pl-4 pr-3 text-sm sm:pl-0">
                        <div className="flex items-center">
                          <div className="size-11 shrink-0">
                            <img
                              alt=""
                              src={`https://api-inventory.neuromotion.tech/images/${product.product_image}`}
                              className="size-11 rounded-full"
                            />
                          </div>
                          <div className="ml-4">
                            <div className="mt-1 text-gray-500">
                              {product.product_name}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                        <div className="text-gray-900">
                          {product.quantity} Packs
                        </div>
                      </td>
                      <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                        <div className="text-gray-900">
                          Rs {product.purchasePricePack}
                        </div>
                      </td>
                      <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                        <div className="text-gray-900">
                          Rs {product.purchasePricePack * product.quantity}
                        </div>
                      </td>
                      <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                        <div className="mt-1 text-gray-500">
                          {product.created_at.slice(0, 10)}
                        </div>
                      </td>
                      <td className="whitespace-nowrap px-3 text-sm text-gray-500">
                        <div className="flex gap-x-4">
                          <FaEdit
                            onClick={() => handleEdit(product)}
                            className="text-yellow-500 text-2xl"
                          />
                          <MdDelete
                            onClick={() => handleDelete(product.id)}
                            className="text-red-500 text-2xl"
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {deletedID && (
        <ConfirmationModal
          visible={visible}
          onCancel={() => CloseModel()}
          onConfirm={() => deletePurcahseCart()}
          message={"Are you sure want to Remove From Purchase order"}
        />
      )}
      {showPaymentModal && (
        <PayPurchaseModel
          visible={showPaymentModal}
          onCancel={() => CloseModel()}
          status={selectedPaymentOption}
          paingamount={() => calculateTotalAmount()}
        />
      )}
      {showEditModal && (
        <EditPurchaseModel
          visible={showEditModal}
          onCancel={() => CloseModel()}
          product={selectedItem}
        />
      )}
    </>
  );
}
